import { render } from "./addbank.vue?vue&type=template&id=5b10b792"
import script from "./addbank.vue?vue&type=script&lang=js"
export * from "./addbank.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__